var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',_vm._l((_vm.cols),function(col,index){return _c('med-record-update-table-col',{key:'row_'+index,attrs:{"body":col,"index":index,"medRecordTemplateFieldValues":_vm.medRecordTemplateFieldValues},on:{"updated":_vm.colUpdated}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }